import { Calculator, Ruler, Clock, BarChart3, BookOpen, Map, CheckSquare, ListOrdered, MousePointerClick, Type, Wrench } from 'lucide-react';
import { RegistryCategory } from './types';
export const VISUAL_CATEGORIES: RegistryCategory[] = [{
  id: 'rekenen',
  label: 'Rekenen & Getallen',
  icon: Calculator,
  description: 'Visualisaties voor getalbegrip, breuken en bewerkingen',
  items: ['numberline', 'numberBoard', 'fraction', 'fractionStrip', 'ratio', 'column', 'equalSharing', 'percentageBar', 'placeValueBlocks', 'barModel', 'splitDiagram']
}, {
  id: 'meten',
  label: 'Meten & Meetkunde',
  icon: Ruler,
  description: 'Lengte, inhoud, gewicht, hoeken en vormen',
  items: ['stairs', 'ruler', 'measuringCup', 'weighScale', 'thermometer', 'protractor', 'circle', 'coordinateGrid', 'box3d', 'compositeShape', 'geometricShape', 'symmetryGrid', 'squareGrid', 'geo']
}, {
  id: 'tijd_geld',
  label: 'Tijd & Geld',
  icon: Clock,
  description: 'Klokken, kalenders, munten en budgetten',
  items: ['clock', 'clock_set', 'digitalClock', 'calendar', 'timeline', 'worldClockPanel', 'money', 'receipt', 'budgetBar', 'priceCompare', 'speedDiagram']
}, {
  id: 'data',
  label: 'Data & Grafieken',
  icon: BarChart3,
  description: 'Diagrammen en grafieken',
  items: ['barChart', 'lineChart']
}, {
  id: 'taal',
  label: 'Taal & Lezen',
  icon: BookOpen,
  description: 'Teksten, grammatica en spelling',
  items: ['verbTable', 'kofschipMnemonic', 'syllableBlocks', 'readingPassage', 'sentenceDiagram', 'wordClassChip', 'signalWordCard', 'synonymAntonymPair', 'textStructureSchema', 'contextSpotlight']
}, {
  id: 'overig',
  label: 'Oriëntatie & Overig',
  icon: Map,
  description: "Kaarten, schema's en algemene ondersteuning",
  items: ['mapScale', 'topoMap', 'rule', 'referenceArrow', 'flowchart', 'mindmap', 'tableOfContents']
}];
export const TYPE_CATEGORIES: RegistryCategory[] = [{
  id: 'standaard',
  label: 'Standaard Vraagtypen',
  icon: CheckSquare,
  description: 'Meerkeuze, invul en goed/fout',
  items: ['multiple_choice', 'fill_in', 'true_false_series']
}, {
  id: 'sorteren',
  label: 'Sorteren & Koppelen',
  icon: ListOrdered,
  description: 'Ordenen, matchen en categoriseren',
  items: ['ordering', 'matching', 'categorize', 'drag_drop_fill', 'fraction_equivalence_match']
}, {
  id: 'interactief_rekenen',
  label: 'Interactief Rekenen',
  icon: Calculator,
  description: 'Cijferend rekenen, tabellen en stapsgewijs oplossen',
  items: ['ratio_table', 'number_sequence', 'cijferend_rekenen', 'cijferend_delen', 'multiplication_grid', 'step_solver', 'comparison_judge', 'double_number_line']
}, {
  id: 'interactief_meten',
  label: 'Interactief Meten & Data',
  icon: MousePointerClick,
  description: 'Grafieken aflezen, klokkijken en geld slepen',
  items: ['table_reading', 'schedule_reading', 'bar_chart', 'line_chart', 'pie_chart', 'clock', 'clock_set', 'money', 'estimation_slider', 'thermometer_slider', 'grid_shade']
}, {
  id: 'interactief_taal',
  label: 'Interactief Taal',
  icon: Type,
  description: 'Tekst markeren, fouten zoeken en zinnen ontleden',
  items: ['text_highlight', 'error_spotting', 'sentence_parser', 'verb_conjugation_flow', 'sentence_error_judge']
}, {
  id: 'geografie',
  label: 'Geografie & Kaart',
  icon: Map,
  description: "Locaties aanwijzen, regio's identificeren en steden plaatsen op de kaart",
  items: ['map_locate_region', 'map_locate_point', 'map_locate_line', 'map_place_cities']
}, {
  id: 'builders',
  label: 'Constructie & Strategie',
  icon: Wrench,
  description: 'Vraagtypen waarbij het kind een antwoord opbouwt of strategie kiest',
  items: ['square_root_builder', 'place_value_build', 'bar_model_part', 'strategy_solver', 'fraction_strip_builder', 'comma_shift']
}];